import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { FiltersWidget } from "../FiltersWidget";
declare var Savane: any;
export class ObjectTypeFilter implements IFilter {
    id: string;
    name?: string | null | undefined;
    type: string;
    nbColums?: number | undefined;
    source?: string | undefined;
    controller: FiltersController;
    parentGroup: FilterGroup;

    //Store history of select group tree (in order)
    static breadcrumbs: any[] = [];

    static objectFilterActivated = parseInt(Savane.SavaneCookie.getCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 0));
    static objectFiltersBySizeActivated = parseInt(Savane.SavaneCookie.getCookie("Rhinov-DesignerFilter-ObjectFilterBySizeEnabled", "" + 0));

    static getInstance(parentGroup: FilterGroup): ObjectTypeFilter | null {
        if (!parentGroup.filters || parentGroup.filters.length === 0) return null;
        return parentGroup.filters.find((filter: IFilter) => filter.id === 'objectType') as ObjectTypeFilter || null;
    }

    constructor(parentGroup: FilterGroup) {
        this.parentGroup = parentGroup;
        this.id = 'objectType';
        this.name = 'Type d\'objet';
        this.type = 'objectType';
        this.controller = new FiltersController();
    }

    static objectFilters() {
        return (ObjectTypeFilter.objectFilterActivated === 1);
    };

    static objectFiltersBySize() {
        return (ObjectTypeFilter.objectFiltersBySizeActivated === 1);
    };

    static toggleObjectFiltersBySize() {
        if (!ObjectTypeFilter.objectFiltersBySize()) {
            ObjectTypeFilter.objectFiltersBySizeActivated = 1;
            Savane.SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterBySizeEnabled", "" + 1);
        }
        else {
            ObjectTypeFilter.objectFiltersBySizeActivated = 0;
            Savane.SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterBySizeEnabled", "" + 0);
        }
        Savane.eventsManager.instance.dispatch(Savane.Events.ENABLE_OBJECT_FILTERS_CHANGED, { forceUpdate: true });
    };

    static toggleObjectFilters() {
        if (!ObjectTypeFilter.objectFilters()) {
            ObjectTypeFilter.objectFilterActivated = 1;
            Savane.SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 1);
        }
        else {
            ObjectTypeFilter.objectFilterActivated = 0;
            Savane.SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 0);
        }
        Savane.eventsManager.instance.dispatch(Savane.Events.ENABLE_OBJECT_FILTERS_CHANGED, { forceUpdate: true });
    };

    static disableObjectFilter() {
        if (ObjectTypeFilter.objectFilters()) {
            ObjectTypeFilter.toggleObjectFilters();
        }
    };

    static updateObjectFiltersIcon() {
        const icon = document.querySelector('#objectFilters .fa-stack-2x') as HTMLElement | null;
        if(!icon) return;
        if (ObjectTypeFilter.objectFilters()) {
            icon.style.display = 'none';
        } else {
            icon.style.display = '';
        }
    }

    updateObjectFiltersBySizeIcon() {
        const icon = document.querySelector('#objectFiltersBySize .fa-stack-2x') as HTMLElement | null;
        if(!icon) return;
        if (ObjectTypeFilter.objectFiltersBySize()) {
            icon.style.display = 'none';
        } else {
            icon.style.display = '';
        }
    }



    searchQuery: string = '';
    selectedObjectTypes: any[] = [];

    updateSelection() {
        $('#treeView').jstree(true).destroy();
        this.selectedObjectTypes = [];
        this.instantiateTree();
    }

    convertObjectType(obj: any) {
        let children = [];
        if (obj.children && obj.children.length > 0) {
            children = obj.children.map((child: any) => this.convertObjectType(child));
        }
        const selected = FilterGroup.filters.objectType && FilterGroup.filters.objectType.some((element: any) => element._id === obj._id);
        if (selected) {
            this.selectedObjectTypes.push(obj);
        }
        return {
            'id': obj._id || '-1',
            'text': obj.name || obj.text,
            'state': {
                'opened': false,
                'selected': selected,
            },
            'children': children,
            'li_attr': {
                'style': 'text-align: left;',
            },
        };
    }

    unselectIndex(index: number) {
        let dif = 0;
        let item;
        if (this.selectedObjectTypes[index] === undefined) {
            console.error("Error: selectedObjectTypes[index] is undefined");
            return;
        };

        if (this.selectedObjectTypes.length === 0) {
            console.error("Error: selectedObjectTypes is empty");
            return;
        }
        for (let i = this.selectedObjectTypes.length - 1; i >= index; i--) {
            item = this.selectedObjectTypes[i];
            $("#treeView").jstree(true).close_all(item);
            $('#treeView').jstree(true).deselect_node(item);
            $(`#node-${item._id}-${i}`).remove();
            this.selectedObjectTypes.splice(i, 1);
            FilterGroup.filters.objectType = this.selectedObjectTypes;
            dif++;
        }
        FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
    }

    convertNodeToHtml(nodeName: string, index: number) {
        const node = this.selectedObjectTypes[index];
        if (!node) return;
        const nodeId = node._id;
        if ($(`#node-${nodeId}-${index}`)) {
            this.controller.removeEventListener('click', `close-${nodeId}-${index}`);
            this.controller.removeEventListener('click', `node-${nodeId}-${index}`);
        }
        setTimeout(() => {
            this.controller.addEventListener('click', () => {
                $(`#node-${nodeId}-${index}`).trigger('focus');
            }, `node-${nodeId}-${index}`);

            this.controller.addEventListener('click', () => {
                this.unselectIndex(index);
            }, `close-${nodeId}-${index}`);
        }, 50);
        return `
        <div class="node" id="node-${nodeId}-${index}" tabindex="-1">
            <span>${nodeName}</span>
            <div class="node-close" id="close-${nodeId}-${index}">
                <i class="fa-solid fa-xmark"></i>
            </div>
        </div>
        `;
    }

    getObjectTypesFromPath(path: string[]) {
        let objectTypes: any[] = [];
        // Always has the .name property
        let parent = FilterGroup.objectTypes.find((element) => element.name === path[0]);
        if (!parent) return objectTypes;
        objectTypes.push(parent);
        for (let i = 1; i < path.length; i++) {
            // Can have either .name or .text property
            parent = parent.children.find((element) => (element.name || element.text) === path[i]);
            if (!parent) return objectTypes;
            objectTypes.push(parent);
        }
        $('#treeViewContainer').addClass('hide-element');
        return objectTypes;
    }

    instantiateTree() {
        let data = FilterGroup.objectTypes.map((element) => this.convertObjectType(element));
        $('#treeView').jstree({
            'core': {
                'themes': {
                    dots: true,
                    responsive: true,
                    stripes: true,
                    name: 'default-dark',
                },
                'data': [
                    ...data,
                ],
                'allow_reselect': true
            },
            'search': {

            },
            'plugins': ["search", "wholerow"],
        });

        $('#treeView').on('changed.jstree', (_e: any, data: any) => {
            const instance: JSTree = data.instance;
            let path = instance.get_path(data.node || data.selected[0]);
            this.selectedObjectTypes = this.getObjectTypesFromPath(path);
            FilterGroup.filters.objectType = this.selectedObjectTypes;
            path = path.map((node: any, index: number) => this.convertNodeToHtml(node, index));
            $('#selectionText').html(path.join(''));
            FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
        });
    }

    html(): string {
        let html = `
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <div class="row" style="max-width: 380px;width: 100%;margin:0 auto;">
                <span>${this.name}</span>
                <div style="display: flex;align-items: center;justify-content: center;">
                    <div id="tree-search-container">
                        <div id="selectionText"></div>
                        <input id="searchInput" type="text" placeholder="Choisissez un type"/>
                    </div>
                    <div id="objectFilters" style="cursor: pointer; padding: 0;" class="col-xs-1">
                        <span class="fa-stack">
                            <i class="fas fa-stack-1x fa-sync-alt" style="line-height: 2em;"></i>
                            '<i class="fas fa-ban fa-stack-2x" style="color:Tomato;${ObjectTypeFilter.objectFilters() ? 'display:none' : ''}"></i>
                        </span>
                    </div>
                    <div id="objectFiltersBySize" style="cursor: pointer; padding: 0;" class="col-xs-1">
                        <span class="fa-stack">
                            <i class="fas fa-stack-1x fa-ruler" style="line-height: 2em;"></i>
                            <i class="fas fa-ban fa-stack-2x" style="color:Tomato;${ObjectTypeFilter.objectFiltersBySize() ? 'display:none' : ''}"></i>'
                        </span>
                    </div>
                </div>
                <div id="treeViewContainer" class="hide-element">
                    <div id="treeView"></div>
                </div>
            </div>
        </div>
        `;

        setTimeout(() => {
            FilterGroup.loadObjectTypes().then(() => {
                if (this.parentGroup.isDestroyed) return;
                this.instantiateTree();

                this.controller.addEventListener('focus', () => {
                    $('#treeViewContainer').removeClass('hide-element');
                }, 'searchInput');

                this.controller.addEventListener('focus', () => {
                    $('#treeViewContainer').addClass('hide-element');
                }, FiltersWidget.tabParentID);

                this.controller.addEventListener('blur', () => {
                    setTimeout(() => {
                        const viewContains = $('#treeViewContainer').has(document.activeElement).length !== 0;
                        const searchContains = $('#tree-search-container').has(document.activeElement).length !== 0;

                        if (!viewContains && !searchContains) {
                            // If you didn't click on the tree view or search container.
                            $('#treeViewContainer').addClass('hide-element');
                        }
                    });
                }, 'searchInput');

                this.controller.addEventListener('input', () => {
                    const searchValue = $('#searchInput').val() as string;
                    this.searchQuery = searchValue;
                    $('#treeView').jstree(true).search(searchValue, true, true, undefined, false, true);
                }, 'searchInput');

                this.controller.addEventListener('click', () => {
                    ObjectTypeFilter.toggleObjectFilters();
                    ObjectTypeFilter.updateObjectFiltersIcon();
                }, ('objectFilters'));

                this.controller.addEventListener('click', () => {
                    ObjectTypeFilter.toggleObjectFiltersBySize();
                    this.updateObjectFiltersBySizeIcon();
                }, ('objectFiltersBySize'));
            });
        }, 50);
        return html;
    }

    destroy(): void {
        $('#treeView').jstree('destroy');
        this.controller.destroy();
    }
}